import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { MenuItem, OutlinedInput } from "@mui/material";
import { BaseMetadataType } from "../../../Core/Api/Types/base-metadata-type";
import { NewRequestMetadataInputProps, NewRequestSelect } from "../new-request-metadata-input";
import { useRef } from "react";

const NewRequestInputStringOrNumberSingle = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, isErrored, onChange } = props;
  const inputRef: any = useRef(null);

  const handleOnChange = (value: any) => {
    let _value: any = null;
    if (metadata.values?.length && metadata.values?.length > 0)
      _value = metadata.values?.find((v) => v.value === value);
    else _value = value;
    onChange(_value);
  };

  return (
    <>
      {metadata.values?.length && metadata.values?.length > 0 ? (
        <NewRequestSelect
          error={isErrored}
          IconComponent={ExpandMoreRoundedIcon}
          value={value?.value || ""}
          onChange={(event) => handleOnChange(event.target.value)}
          onFocus={(e) => inputRef.current?.focus()}
          MenuProps={{
            PaperProps: { sx: { maxHeight: 400, maxWidth: 250 } },
            variant: "selectedMenu",
          }}
        >
          {metadata.values?.map((value, index) => (
            <MenuItem ref={index === 0 ? inputRef : null} key={index} value={value.value!} dense>
              {value.label!}
            </MenuItem>
          ))}
        </NewRequestSelect>
      ) : (
        <OutlinedInput
          tabIndex={0}
          id={metadata.tagName!}
          // value management
          value={value || ""}
          onKeyDown={(e) => {
            if (e.code === "Space" || e.code === "ArrowLeft" || e.code === "ArrowRight") e.stopPropagation();
          }}
          onChange={(event) => handleOnChange(event.target.value)}
          // input rendering
          size="small"
          error={isErrored}
          type={metadata.baseType === BaseMetadataType.DbStringMetadataValueInfos ? "text" : "number"}
          sx={{ width: "100%" }}
        />
      )}
    </>
  );
};

export default NewRequestInputStringOrNumberSingle;
